import type { FollowUpReasonStringEnum } from "parog-web/models/patient-enrolled-journal-event";

/**
 * Here to make the corresponding between the attribute in the CSV file
 * and our Patient attributes.
 */
export const correspondenceTable: Map<string, string> = new Map([
  // Patient
  ["Prénom", "firstName"],
  ["Nom marital", "lastName"],
  ["Nom de naissance", "birthName"],
  ["Date de naissance Receveur", "birthday"],
  ["Sexe Receveur", "gender"],
  ["Adresse e-mail du patient", "email"],
  ["Téléphone receveur habituel", "phone"],
  ["Adresse résidence habituelle", "address"],
  ["Code postal résidence habituelle", "postcode"],
  ["Ville résidence habituelle", "city"],
  ["Complément adresse résidence habituelle", "moreAddressInformation"],
  ["Numéro IPP", "ippNumber"],
  ["Numéro sécu", "insuredSocialSecurityNumber"],
  ["Médecin référent", "medics"],
  // Health Centre
  ["ID du centre", "healthCentre"],
  // Medical History
  ["Objet de suivi", "importedFollowUpReason"],
  ["Date de greffe", "transplantDate"],
  ["Néphropathie", "nephropatie"],
  ["Type de donneur attendu", "donorType"],
  ["Stade de MRC", "mrcStage"],
  ["Type de dialyse", "dialysisType"],
  ["Lieu d’hémodialyse", "dialysisCareLocation"]
]);

export const dialysisTypeTable: Map<string, DialysisTypeStringEnum> = new Map([
  ["Hémodialyse", "hemodialysis"],
  ["Dialyse péritonéale", "peritoneal-dialysis"]
]);

export const dialysisCareLocationTable: Map<
  string,
  DialysisCareLocationStringEnum
> = new Map([
  ["A domicile", "at-home"],
  ["En UAD", "in-uad"],
  ["En UDM", "in-udm"],
  ["En centre lourd", "in-intensive-care"]
]);

export const dialysisTypeValues = [
  "hemodialysis",
  "peritoneal-dialysis"
] as const;

export type DialysisTypeStringEnum =
  | (typeof dialysisTypeValues)[number]
  | false;

export type DialysisCareLocationStringEnum =
  | "at-home"
  | "in-uad"
  | "in-udm"
  | "in-intensive-care";

export const followUpReasonTable: Map<string, FollowUpReasonStringEnum> =
  new Map([
    ["Suivi générique", "generic-general"],

    // Nephro
    ["Greffe de rein", "nephro-transplant"],
    ["Donneur", "nephro-donor"],
    ["MRC", "nephro-mrc"],
    ["Suivi générique en néphrologie", "nephro-generic"],

    // Pneumo
    ["Greffe de poumon", "pneumo-transplant"],
    ["Suivi générique en pneumologie", "pneumo-generic"],

    // Hepato
    ["Greffe de foie", "hepato-transplant"],
    ["Suivi générique en hépatologie", "hepato-generic"],

    // Onco
    ["Cancer du sein (TNM)", "onco-breast-cancer-tnm0"],
    ["Cancer du sein", "onco-breast-cancer"],
    ["Lymphome", "onco-lymphoma-cancer"],
    ["Myélome", "onco-myeloma-cancer"],
    ["Cancer hématologique", "onco-hemato-cancer"],
    ["Cancer du côlon", "onco-colon-cancer"],
    ["Cancer du poumon", "onco-lung-cancer"],
    ["Cancer de la prostate", "onco-prostate-cancer"],
    ["Cancer de l'ovaire", "onco-ovarian-cancer"],
    ["Cancer des testicules", "onco-testicular-cancer"],
    ["Cancer du cerveau", "onco-brain-cancer"],
    ["Cancer du pancréas", "onco-pancreatic-cancer"],
    ["Cancer du foie", "onco-liver-cancer"],
    ["Cancer du rein", "onco-kidney-cancer"],
    ["Cancer de l'estomac", "onco-stomach-cancer"],
    ["Cancer du col de l'utérus", "onco-cervix-cancer"],
    ["Cancer de la peau", "onco-skin-cancer"],
    ["Suivi générique en oncologie", "onco-generic"],

    // Cardio
    ["Greffe de coeur", "cardio-transplant"],
    ["Insuffisance cardiaque", "cardio-heart-failure"],
    ["Suivi générique en cardiologie", "cardio-generic"],

    // Mental
    ["Trouble bipolaire", "mental-bipolar"],
    ["Dépression", "mental-depression"],
    ["Suivi générique en santé mentale", "mental-generic"],

    // Diabeto
    ["Diabète de type 2", "diabeto-dt2"],
    ["Suivi générique en diabétologie", "diabeto-generic"],

    // Gastro
    ["Maladie de Crohn", "digest-crohn"],
    ["RCH", "digest-rch"],
    ["Suivi générique en gastroentérologie", "digest-generic"]
  ]);
